import React, { useEffect, useState, useMemo } from "react";
import { api } from "../../api";
import { motion } from "framer-motion";

export default function Withdrawals() {
  const [withdrawals, setWithdrawals] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [searchPhone, setSearchPhone] = useState("");

  const isSearching = searchPhone.trim().length > 0;

  const fetchWithdrawals = async (pageNumber = 1, phone = "") => {
    try {
      const res = await api.get("/withdrawals", {
        params: { page: pageNumber, pageSize, phone }, // ✅ send phone
      });

      const withdrawalsArray = Array.isArray(res.data.withdrawals?.withdrawals)
        ? res.data.withdrawals.withdrawals
        : [];

      setWithdrawals(withdrawalsArray);
      setTotalPages(res.data.withdrawals?.totalPages || 1);
      setPage(pageNumber);
    } catch (err) {
      console.error(
        "❌ Error fetching withdrawals:",
        err.response?.data || err.message,
      );
      setWithdrawals([]);
      setTotalPages(1);
    }
  };

  // Approve Withdrawal
  const handleApprove = async (id) => {
    try {
      await api.put(`/withdrawals/approve/${id}`);
      alert("Withdrawal success!");
      fetchWithdrawals(page);
    } catch (err) {
      console.error("Error success:", err.response?.data || err.message);
      alert("Error approving withdrawal");
    }
  };

  useEffect(() => {
    fetchWithdrawals(page, searchPhone);
  }, [page, searchPhone]);

  return (
    <motion.div
      className="bg-black/40 p-6 rounded-2xl shadow-lg"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <h2 className="text-2xl font-semibold mb-4">Withdrawals</h2>

      {/* 🔍 Phone Search */}
      <div className="mb-4 flex justify-end">
        <input
          type="text"
          placeholder="Search by phone number..."
          value={searchPhone}
          onChange={(e) => setSearchPhone(e.target.value)}
          className="w-full md:w-1/4 px-4 py-2 rounded bg-black/60 border border-gray-600 text-white"
        />
      </div>

      <table className="w-full text-left">
        <thead>
          <tr className="border-b border-gray-600">
            <th className="p-2">Phone</th>
            <th className="p-2">Amount</th>
            <th className="p-2">Bank</th>
            <th className="p-2">Status</th>
            <th className="p-2">Date</th>
          </tr>
        </thead>

        <tbody>
          {withdrawals.length === 0 ? (
            <tr>
              <td colSpan={5} className="text-center py-4 text-gray-400">
                No withdrawals found.
              </td>
            </tr>
          ) : (
            withdrawals.map((w) => (
              <tr key={w.id} className="border-b border-gray-700">
                <td className="p-2">{w.phone}</td>
                <td className="p-2">{w.amount}</td>
                <td className="p-2">{w.bank}</td>
                <td className="p-2">
                  {w.status === "pending" ? (
                    <button
                      onClick={() => handleApprove(w.id)}
                      className="bg-yellow-600 px-3 py-1 rounded text-black font-semibold hover:bg-yellow-500"
                    >
                      Pending
                    </button>
                  ) : (
                    <span className="bg-green-600 px-3 py-1 rounded text-white font-semibold">
                      Success
                    </span>
                  )}
                </td>
                <td className="p-2">{w.createdAt?.split("T")[0]}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* Pagination */}
      <div className="flex justify-between mt-4">
        <button
          disabled={page === 1}
          onClick={() => setPage((p) => p - 1)}
          className="bg-blue-700 px-4 py-2 rounded disabled:opacity-50"
        >
          Previous
        </button>

        <span className="text-gray-300 px-2 py-2">
          {searchPhone
            ? `Search results • Page ${page} of ${totalPages}`
            : `Page ${page} of ${totalPages}`}
        </span>

        <button
          disabled={page === totalPages}
          onClick={() => setPage((p) => p + 1)}
          className="bg-blue-700 px-4 py-2 rounded disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </motion.div>
  );
}
